import { useEffect, useState } from 'react';
import { Loader2Icon } from 'lucide-react';

const CalendlyCallback = () => {
  const [status, setStatus] = useState('processing'); // 'processing', 'success', 'error'
  const [message, setMessage] = useState('Processing Calendly connection...');

  useEffect(() => {
    const handleCallback = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const statusParam = urlParams.get('status');
      const error = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');

      if (error) {
        setStatus('error');
        setMessage(errorDescription || 'Calendly connection failed');
        // Don't close on error - let user see the error and close manually
        return;
      }

      if (statusParam === 'success') {
        setStatus('success');
        setMessage('Calendly connected successfully!');
        // Close window after showing success
        setTimeout(() => {
          window.close();
        }, 1000);
      } else {
        // Still processing or unknown status
        setStatus('processing');
        setMessage('Processing Calendly connection...');
      }
    };

    handleCallback();
  }, []);

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'text-green-600';
      case 'error':
        return 'text-red-600';
      default:
        return 'text-blue-600';
    }
  };

  const getStatusIcon = () => {
    if (status === 'processing') {
      return <Loader2Icon className='h-8 w-8 animate-spin text-blue-600' />;
    }
    return null;
  };

  return (
    <div className='flex min-h-screen items-center justify-center bg-background p-4'>
      <div className='max-w-md space-y-4 text-center'>
        <div className='flex justify-center'>{getStatusIcon()}</div>
        <h2 className='text-xl font-semibold'>Calendly Connection</h2>
        <p className={`text-lg ${getStatusColor()}`}>{message}</p>
        {status === 'success' && (
          <p className='text-sm text-muted-foreground'>
            This window will close automatically...
          </p>
        )}
        {status === 'error' && (
          <p className='text-sm text-muted-foreground'>
            You can close this window manually.
          </p>
        )}
      </div>
    </div>
  );
};

export default CalendlyCallback;
